const TONES = {
  paper: 'bg-paper text-ink',
  white: 'bg-white text-ink',
  dark: 'bg-ink text-white on-dark',
};

export function Container({ className = '', children }) {
  return <div className={`mx-auto max-w-7xl px-6 lg:px-8 ${className}`}>{children}</div>;
}

export default function Section({ id, tone = 'paper', className = '', children }) {
  return (
    <section id={id} className={`${TONES[tone]} py-20 sm:py-28 ${className}`}>
      <Container>{children}</Container>
    </section>
  );
}

export function SectionHeading({ eyebrow, title, text, tone = 'paper', className = '' }) {
  const dark = tone === 'dark';
  return (
    <div className={`max-w-2xl ${className}`}>
      {eyebrow && (
        <span className={`eyebrow mb-4 flex items-center gap-3 ${dark ? 'text-white/70' : 'text-ink/60'}`}>
          <span className="h-px w-8 bg-brand" aria-hidden="true" />
          {eyebrow}
        </span>
      )}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">{title}</h2>
      {text && (
        <p className={`mt-5 text-lg leading-relaxed ${dark ? 'text-white/75' : 'text-ink/70'}`}>{text}</p>
      )}
    </div>
  );
}
